module.exports = __webpack_public_path__ + "static/img/icon-evaluate-2.fefca17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-evaluate-2.jpg
// module id = f4lM
// module chunks = 21